
window.ProductPricing = {
  getDisplayPrice(variant) {

    if (!variant) return 0;

    try {

      const shopliftPrice =
        window.shopliftInstance?.state?.price;

      if (shopliftPrice) {
        return Number(shopliftPrice);
      }

    } catch(e) {
      console.warn('Shoplift price lookup failed', e);
    }

    return Number(variant.price || 0);
  }
};


document.addEventListener("DOMContentLoaded", function() {
  requestAnimationFrame(() => {
    var link = document.querySelector(".ht-google-map-button-area a");
    if (link) {
        link.classList.add("button");
    }


    const parentDiv = document.querySelector('.product-info__block-list');
    if (!parentDiv) return;

    const secondChild = parentDiv.querySelector('[data-block-type="price"]');
    const thirdChild = parentDiv.querySelector('[data-block-type="@app"]');

    if (secondChild && thirdChild) {
      // Create wrapper div
      const wrapper = document.createElement('div');
      wrapper.classList.add('new-parent-div');

      // Insert wrapper before the first element to wrap
      parentDiv.insertBefore(wrapper, secondChild);

      // Move both children into wrapper
      wrapper.appendChild(secondChild);
      wrapper.appendChild(thirdChild);
    }
  });
});



/*  FOR FUTURE REFERENCE, PLACE HERE --> Scripts for product pages: Unifying here the scripts formerly in 
    main-product.liquid & marine-vinyl-main-product.liquid ( + product-info-marine-vinyl.liquid? ) */
// --- Shoplift: re-apply prices after variant change ---
(function () {
  var APPLIED_ATTR = 'data-sl-applied';

  function getActiveHypothesisId() {
    var value = window.__shopliftPriceTestValue || '';
    // formato: testId:hypothesisType:flag
    // hypothesisType: 'control' = isControl:true, qualquer outro = busca pelo título
    var parts = value.split(':');
    return parts[1] || null; // 'control' ou outro identificador
  }

  function applyShoplift() {
    try {
      var activeType = getActiveHypothesisId();
      var configs = Object.values(window.shopliftInstance?.testConfigs ?? {});

      configs.forEach(function(test) {
        if (!test.hypotheses) return;

        // Encontra o hypothesis correto baseado no _slpt
        var active;
        if (activeType === 'control') {
          active = test.hypotheses.find(function(h) { return h.isControl; });
        } else {
          // Para grupos não-control, usa trafficPercentage > 0 e não isControl
          active = test.hypotheses.find(function(h) { return !h.isControl && h.trafficPercentage > 0; });
        }

        if (!active?.domSelectors) return;

        active.domSelectors.forEach(function(selector) {
          document.querySelectorAll(selector.cssSelector).forEach(function(el) {
            selector.actions?.forEach(function(action) {
              if (action.type === 'innerHtml') {
                if (el.getAttribute(APPLIED_ATTR) !== action.value) {
                  el.innerHTML = action.value;
                  el.setAttribute(APPLIED_ATTR, action.value);
                }
              } else if (action.type === 'remove') {
                el.remove();
              } else if (action.type === 'js') {
                try { new Function('element', action.value)(el); } catch (_) {}
              }
            });
          });
        });
      });
    } catch (_) {}
  }


  let debounceTimer;
  function debouncedApply(mutations) {
    // ignora mutações que são só adição do data-sl-applied
    const isOnlyOurAttr = mutations.every((m) =>
      m.type === 'attributes' && m.attributeName === APPLIED_ATTR
    );
    if (isOnlyOurAttr) return;

    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(applyShoplift, 80);
  }

  function startObserver() {
    const observer = new MutationObserver(debouncedApply);
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: [APPLIED_ATTR]
    });
  }

  function waitForShoplift(retries) {
    if (retries === undefined) retries = 20;
    if (window.shopliftInstance && window.shopliftInstance.testConfigs) {
      applyShoplift();
      startObserver();
      return;
    }
    if (retries > 0) setTimeout(function() { waitForShoplift(retries - 1); }, 150);
  }

  document.addEventListener('DOMContentLoaded', function() { waitForShoplift(); });
})();

console.log('custom v1.1');